import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-global-loader',
  imports: [CommonModule],
  template: `
    <div class="loader-overlay">
      <div class="loader-card">

        <!-- ✅ Powerful Multi-Layer Spinner -->
        <div class="super-spinner">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <!-- ✅ Stacked CRM Branding -->
        <div class="brand-stack">
          <div class="animated-text2">FlowDrizzle</div>
        </div>

      </div>
    </div>
  `,
  styles: [`
    .loader-overlay {
      position: fixed;
      inset: 0;
      background: rgba(15, 23, 42, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 900;
      backdrop-filter: blur(2px);
    }

    .loader-card {
      padding: 48px 70px;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 26px;
      animation: popIn 0.25s ease-out;
    }

    .super-spinner {
      position: relative;
      width: 90px;
      height: 90px;
    }

    .super-spinner span {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      border: 4px solid transparent;
      animation: turboSpin 1.2s linear infinite;
    }

    .super-spinner span:nth-child(1) {
      border-top: 4px solid #2563eb;
      border-right: 4px solid #2563eb;
    }

    .super-spinner span:nth-child(2) {
      inset: 10px;
      border-top: 4px solid #4f46e5;
      border-left: 4px solid #4f46e5;
      animation-duration: 0.9s;
    }

    .super-spinner span:nth-child(3) {
      inset: 20px;
      border-top: 4px solid #22c55e;
      border-right: 4px solid #22c55e;
      animation-duration: 0.6s;
    }

    .brand-stack {
      text-align: center;
    }

    .animated-text2 {
      font-size: 24px;
      font-weight: 800;
      letter-spacing: 2px;
      background: linear-gradient(90deg, #2563eb, #4f46e5, #2563eb);
      background-size: 200%;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: glowText 1.6s linear infinite;
    }

    @keyframes turboSpin {
      100% { transform: rotate(360deg); }
    }

    @keyframes glowText {
      0% { background-position: 0%; }
      100% { background-position: 200%; }
    }

    @keyframes popIn {
      from { opacity: 0; transform: scale(0.95); }
      to { opacity: 1; transform: scale(1); }
    }
  `]
})
export class GlobalLoaderComponent {}
